import classNames from 'classnames';
import React, { useMemo } from 'react';
import './product-pricing.scss';

interface ProductPricingProps {
  regularPrice: string;
  /**
   * Suggested retail price, the price that will be strikethrough as the price before discount
   */
  srpPrice: string;
  pricePrefix?: string;
  /**
   * Size of the component's text. 'sm' can be used for product listing, 'lg' is for product details page
   */
  variant: 'sm' | 'lg';
}

const ProductPricing = ({ regularPrice, srpPrice, pricePrefix, variant }: ProductPricingProps) => {
  const discountedPercentageInt = useMemo(() => {
    const result = ((parseFloat(srpPrice) - parseFloat(regularPrice)) / parseFloat(srpPrice)) * 100;
    return Math.ceil(result);
  }, [regularPrice, srpPrice]);

  return (
    <div className={classNames("product-pricing-component", {
      'product-pricing-component--sm': variant === 'sm',
      'product-pricing-component--lg': variant === 'lg',
    })}>
      <h4 className={classNames("product-pricing-component__price-field", {
        'product-pricing-component__price-field--sm': variant === 'sm',
        'product-pricing-component__price-field--lg': variant === 'lg',
      })}>
        {pricePrefix}
        {parseFloat(regularPrice).toFixed(2)}
      </h4>
      {(
        <div className="product-pricing-component__srp-group">
          {
            srpPrice && discountedPercentageInt > 0 && 
            <>
              <span className={classNames("product-pricing-component__srp-group__before-discount", {
                'product-pricing-component__srp-group__before-discount--sm': variant === 'sm',
                'product-pricing-component__srp-group__before-discount--lg': variant === 'lg',
              })}>
                {pricePrefix}
                {parseFloat(srpPrice).toFixed(2)}
              </span>
              <span className={classNames("product-pricing-component__srp-group__discount-percentage", {
                'product-pricing-component__srp-group__discount-percentage--sm': variant === 'sm',
                'product-pricing-component__srp-group__discount-percentage--lg': variant === 'lg',
              })}>
                -{discountedPercentageInt}%
              </span>
            </>
          }
        </div>
      )}
    </div>
  );
};

export default ProductPricing;
